// TYPES
import { Entity } from "../../types";

// COMPONENTS
import { Icon } from "@allaria-tech/matter/Icon";
import { IconButton } from "@allaria-tech/matter/IconButton";
import { Typography } from "@allaria-tech/matter/Typography";

import styles from "./EntitySelector.module.scss";

interface EntityCardProps {
  id: string;
  entity: Entity;
  onClick: () => void;
  onEdit: () => void;
  isCompletedEntity?: boolean;
  isActive: boolean;
  disabled?: boolean;
  showEditAction?: boolean;
}

const EntityCard = ({
  id,
  entity,
  isActive,
  onClick,
  onEdit,
  isCompletedEntity,
  disabled,
  showEditAction,
}: EntityCardProps) => {
  const {
    entityContainer,
    active,
    notClickable,
    entityContent,
    entityName,
    entityEdit,
  } = styles;

  // Mobile names the entity on the card instead of tagging it with its role,
  // and carries its own edit affordance rather than the active-card outline
  const leading = showEditAction ? (
    <>
      {!isCompletedEntity && (
        <Icon
          name="warning-filled"
          size="sm"
          color="var(--icon-feedback-warning, #dea916)"
          label={`${entity.label} incompleto`}
        />
      )}
      <Icon name="user-2" size="sm" />
    </>
  ) : (
    <Icon
      name={isCompletedEntity ? "success-filled" : "warning-filled"}
      color={
        isCompletedEntity
          ? "var(--icon-feedback-success, #18974a)"
          : "var(--icon-feedback-warning, #dea916)"
      }
    />
  );

  const trailing = showEditAction ? (
    <IconButton
      className={entityEdit}
      variant="outline"
      size="small"
      aria-label={`Editar ${entity.label}`}
      icon={<Icon name="edit" size="sm" />}
      onClick={onEdit}
    />
  ) : (
    <Icon name="chevron-right" size="sm" color="var(--icon-base, #3f4f69)" />
  );

  return (
    <div
      id={id}
      className={`${entityContainer} ${isActive ? active : ""} ${
        disabled ? notClickable : ""
      }`}
      onClick={onClick}
    >
      <div className={entityContent}>
        {leading}
        <Typography
          className={entityName}
          type={showEditAction ? "HEADING" : "LABEL"}
          size={showEditAction ? "S" : "M"}
          weight="EMPHASIS"
          color={
            entity.value
              ? undefined
              : "var(--typography-label-color-disabled, #8690a1)"
          }
        >
          {entity.value || entity.placeholder}
        </Typography>
        {!showEditAction && (
          <Typography type="LABEL" size="S">
            {entity.label}
          </Typography>
        )}
      </div>
      {!disabled && trailing}
    </div>
  );
};

export default EntityCard;
